import { useLayoutEffect, useState } from 'react';
import { ThemeContext } from '../../constants/themes';
import { useHistory } from "react-router-dom";
import Type from '../../components/atoms/Type';
import Button from '../../components/atoms/Button';
import Loader from '../../components/atoms/Loader';
import Navbar from '../../components/molecules/Navbar';
import Authenticator from '../../components/molecules/Authenticator';
import TextSubmit from '../../components/molecules/TextSubmit';
import { ReactComponent as ArrowDownward } from '../../assets/img/arrow-downward.svg';
import { withAuth0 } from "@auth0/auth0-react";
import Parrot from '../../api/parrot';
import './index.css';

const parrot = new Parrot();

const Landing = (props) => {
  let history = useHistory();

  const [state, setState] = useState({
    step: 0,
    scrollPosition: 0,
    url: undefined,
    rssLink: undefined,
    credits: 0,
    pendingRecordingRequestUrl: undefined,
    pendingRecordingRequestLoading: false,
    pendingRecordingRequestSubmitting: false,
    pendingRecordingRequest: undefined,
    urlInputIsLoading: false
  });

  useLayoutEffect(() => {
    const fetchData = async () => {
      let nextStep = 0;
      const url = localStorage.getItem('url');
      if (url !== undefined && url !== null) {
        nextStep = 2;
        if (props.auth0.isAuthenticated) {
          setState({
            ...state,
            step: nextStep,
            pendingRecordingRequestLoading: true
          });
          try {
            const accessToken = await props.auth0.getAccessTokenSilently();
            parrot.getArticleInfo(accessToken, {article_url: url}).then(response => {
              parrot.getUserInfo(accessToken).then(userInfo => {
                if (userInfo) {
                  props.mixpanel?.identify(userInfo.id);
                  props.mixpanel?.people?.set({
                    "Full name": userInfo.full_name,
                    "$email": userInfo.email,
                    "Sign up date": new Date().getTime(),
                    "USER_ID": userInfo.id
                  });
                  setState({
                    ...state,
                    step: nextStep,
                    credits: userInfo.credits,
                    pendingRecordingRequestUrl: url,
                    pendingRecordingRequestLoading: false,
                    pendingRecordingRequest: {
                      title: response.title,
                      credits: response.credits
                    },
                    rssLink: userInfo.rss_url
                  });
                }
              });
            });
          } catch (err) {
            setState({
              ...state,
              step: nextStep,
              pendingRecordingRequestLoading: false
            })
            console.log(err);
          }
        }
      };
    }
    props.mixpanel?.track("Landing Visit");
    fetchData();
  }, [])

  const nextStep = (dataObject) => {
    // Skip auth if already authed
    if (state.step + 1 === 1 && props.auth0.isAuthenticated) {
      setState({
        ...state,
        step: state.step + 2,
        ...dataObject,
        urlInputIsLoading: false
      });
    } else if (state.step + 1 === 2 && !props.auth0.isAuthenticated) {
      setState({
        ...state,
        step: state.step,
        ...dataObject,
        urlInputIsLoading: false
      });
    } else {
      setState({
        ...state,
        step: state.step + 1,
        ...dataObject,
        urlInputIsLoading: false
      });
    }
  }

  const consumeURL = (url) => {
    localStorage.setItem('url', url);
    setState({
      ...state,
      pendingRecordingRequestUrl: url,
      urlInputIsLoading: true,
    });
    nextStep({ url });
  }

  const submitRecordingRequest = async () => {
    setState({
      ...state,
      pendingRecordingRequestSubmitting: true
    })
    const accessToken = await props.auth0.getAccessTokenSilently();
    parrot.confirmRequestNarration(accessToken, {article_url: localStorage.getItem('url')}).then(res => {
      // TODO: Anything here?
      localStorage.removeItem('url');
      nextStep({ pendingRecordingRequestSubmitting: false });
    });
  }

  const cancelRecordingRequest = () => {
    localStorage.removeItem('url');
    history.push("/dashboard");
  }

  const scrollDown = (amountToScroll) => {
    window.scrollTo(0, amountToScroll);
  }

  const renderStep = () => {
    if (state.step === 0) {
      return (
        <>
          <Type type="h1" style={{ maxWidth: '15em', margin: 0 }}>Have articles read to you by real humans within 24 hours.</Type>
          <Type>Sent directly to wherever you listen to podcasts.</Type>
          {!props.auth0.isAuthenticated ?
            <TextSubmit placeholder="Enter a link to an article →" initialValue={state.pendingRecordingRequestUrl || undefined} type="url" buttonText="Submit" isLoading={state.urlInputIsLoading} onSubmit={consumeURL} style={{ maxWidth: '30em' }} />
            :
            null
          }
        </>
      );
    } else if (state.step === 1) {
      return (
        <>
          <Authenticator type="signup" onFinish={nextStep} />
        </>
      );
    } else if (state.step === 2) {
      if (state.pendingRecordingRequestLoading) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
            <Type type="h1" style={{ maxWidth: '15em', margin: 0 }}>Processing your article...</Type>
            <Loader style={{ margin: 0, padding: 0 }} />
          </div>
        );
      } else if (state.pendingRecordingRequest.credits !== null) {
        return (
          <>
            {state.pendingRecordingRequest !== undefined ?
              (state.pendingRecordingRequest?.credits > state.credits ?
                <>
                  <Type type="h1" style={{ maxWidth: '15em', margin: 0 }}>You don't have enough credits.</Type>
                  <Type>Sorry, you don't have enough credits to request a recording of "{state.pendingRecordingRequest?.title}".</Type>
                  <div>
                    <Type>You have: {state.credits} credits</Type>
                    <Type>Cost: {state.pendingRecordingRequest?.credits} credits</Type>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Button value="Get more credits" onClick={cancelRecordingRequest} />
                    <Button type="secondary" value="Return to dashboard" onClick={cancelRecordingRequest} />
                  </div>
                </>
                :
                <>
                  <Type type="h1" style={{ maxWidth: '15em', margin: 0 }}>Confirm recording request.</Type>
                  <Type>{state.pendingRecordingRequest?.title}</Type>
                  <Type style={{ margin: 0 }}>{state.pendingRecordingRequestUrl}</Type>
                  <div>
                    <Type>You have: {state.credits} credits</Type>
                    <Type>Cost: {state.pendingRecordingRequest?.credits} credits</Type>
                  </div>
                  {state.pendingRecordingRequestSubmitting ?
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                      <Loader style={{ margin: 0 }} />
                    </div>
                    :
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                      <Button disabled={state.pendingRecordingRequest === undefined} value="Submit" onClick={submitRecordingRequest} />
                      <Button type="secondary" value="Cancel" onClick={cancelRecordingRequest} />
                    </div>
                  }
                </>
              )
              :
              <div className="modal-loader-div">
                <Loader style={{ margin: 'auto' }} />
              </div>
            }
          </>
        );
      } else {
        return (
          <>
            <Type type="h1" style={{ maxWidth: '15em', margin: 0 }}>Link to your podcast client.</Type>
            <Type>Add this RSS feed URL to your podcast client to receive the human recording of that content when it’s ready.</Type>
            <TextSubmit placeholder="Article link here" readonly initialValue={state.rssLink} buttonText="Copy" type="copy" onSubmit={consumeURL} style={{ maxWidth: '30em' }} />
            <br />
            {state.pendingRecordingRequestSubmitting ?
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                <Loader style={{ margin: 0 }} />
              </div>
              :
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                <Button value="I added it" onClick={submitRecordingRequest} />
                <Button type="secondary" value="I need help doing this" href={'https://transistor.fm/add-podcast/'} openInNewTab />
              </div>
            }
          </>
        );
      }
    } else if (state.step === 3) {
      return (
        <>
          <Type type="h1" style={{ maxWidth: '15em', margin: 0 }}>Recording in progress.</Type>
          <Type style={{ margin: '1em 0 0.5em 0' }}>The human recording of that content will be available in your podcast client within 24 hours.</Type>
          <Type style={{ margin: 0 }}>Head to your dashboard to view the status of articles you've requested recording for.</Type>
          <br />
          <Button value="Go to my dashboard" href='/dashboard' />
        </>
      );
    }
  }

  return (
    <ThemeContext.Consumer>
      {themeContext => (
        props.auth0.isLoading ?
          <div className="loading-background" style={{ backgroundColor: themeContext.theme.body }}>
            <Loader style={{ margin: 'auto' }} />
          </div>
          :
          <div className="background" style={{ backgroundColor: themeContext.theme.body }}>
            <Navbar promptDashboard={state.step < 2} promptSettings={state.step < 2} authed={props.auth0.isAuthenticated} />
            <div className="landing-content-div">
              {renderStep()}
            </div>
            {state.step === 0 ?
              <div className="landing-details-div">
                <a onClick={() => scrollDown(window.screen.height * 0.8)} style={{ cursor: 'pointer' }}><div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItem: 'center' }}>
                  <Type type="h2" style={{ marginRight: 4 }}>What does this do?</Type>
                  <ArrowDownward width={36} fill={themeContext.theme.text} />
                </div></a>
                <Type style={{ margin: 0, padding: 0 }}>Turn any article, newsletter, or Twitter thread, into a real, human-narrated podcast episode within 24 hours.</Type>
                <Type>It shows up wherever you listen to podcasts. Automagically.</Type>
                <Type type="h2">How does this work?</Type>
                <Type>1. Request an article narration above.</Type>
                <Type type="caption" style={{ color: themeContext.theme.text, margin: '4px 0' }}>Your first article request is 100% free. No credit card required.</Type>
                <Type type="caption" style={{ color: themeContext.theme.text, margin: '4px 0' }}>After your first request, you can subscribe to ReadMeThis for $10.00/month to receive 1000 credits/month. Spend these credits to request future article narrations.</Type>
                <Type type="caption" style={{ color: themeContext.theme.text, margin: '4px 0' }}>The cost of an article depends on its word count. You'll typically get 5-6 articles per month.</Type>
                <Type>2. Wait for a real human to narrate your requested article.</Type>
                <Type type="caption" style={{ color: themeContext.theme.text, margin: '4px 0' }}>ReadMeThis guarantees a sub-24-hour delivery.</Type>
                <Type>2. Enjoy your narrated Internet content.</Type>
                <Type type="caption" style={{ color: themeContext.theme.text, margin: '4px 0' }}>Your narrated article will show up in your podcast client.</Type>
              </div>
              :
              null
            }
          </div>
      )}
    </ThemeContext.Consumer>
  );
}

export default withAuth0(Landing);
